const actions = {
  SET_STATE: 'agenda/SET_STATE',
  GET_AGENDA: 'agenda/GET_AGENDA',
  GET_SPEAKERS: 'agenda/GET_SPEAKERS',
}

export default actions
